(function () {
  'use strict';
  if (window.FCSCollectionAbout) return;
  function enhance(scope) {
    scope.querySelectorAll('.fcs-collection-about').forEach(section => {
      section.querySelectorAll('.rte button').forEach(button => {
        const link = button.firstElementChild;
        if (button.childElementCount !== 1 || link?.tagName !== 'A' || button.hasAttribute('onclick') || button.disabled || button.textContent.trim() !== link.textContent.trim()) return;
        link.classList.add('fcs-collection-about__button');
        button.replaceWith(link);
      });
      section.querySelectorAll('.rte a.fcs-collection-about__button,.rte a.button,.rte a.btn').forEach(link => {
        if (link.querySelector('[data-fcs-about-arrow]')) return;
        const arrow = section.querySelector('[data-fcs-about-arrow-template]')?.content.cloneNode(true);
        if (arrow) link.append(arrow);
      });
    });
  }
  window.FCSCollectionAbout = { enhance };
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
